import { Outlet } from 'react-router-dom';

import { GlobalLoginModal } from '@elements';

export const LayoutRoute = () => {
  return (
    <>
      <Outlet />
      <GlobalLoginModal />
    </>
  );
};
